<style lang="less" scoped>
 .card-style {
     margin-top: 10px;
 }
 .subject-iteration-contain {
   overflow: auto;
   .vuetify-page {
     display: flex;
     align-items: center;
   }
 }
</style>
<template>
  <div
    class="subject-iteration-contain"
    :style="{
      height: containHeight+'px'
    }"
  >
    <v-tabs
      v-model="selected_tab"
      background-color="transparent"
      color="basil"
      @change="changeTab"
    >
      <v-tab
        v-for="item in tabs_list"
        :key="item.value"
        :href="`#${item.value}`"
      >
        {{ item.title }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selected_tab">
      <v-tab-item
        v-for="item in tabs_list"
        :key="item.value"
        :value="item.value"
      >
        <v-card
          v-show="selected_tab===tabs_list[0].value"
          class="card-style"
        >
          <TabItem
            :show-search="true"
            search-placehold="请输入费用名称、关键字"
            :props-params="expenseNatureProps"
          />
        </v-card>
        <v-card
          v-show="selected_tab===tabs_list[1].value"
          class="card-style"
        >
          <TabItem
            :props-params="functionalProps"
          />
        </v-card>
        <v-card
          v-show="selected_tab===tabs_list[2].value"
          class="card-style"
          :style="{
            height: (containHeight-50)+'px'
          }"
        >
          <TabItem
            :props-params="getItemTypeListProps"
          />
        </v-card>
        <v-card
          v-show="selected_tab===tabs_list[3].value"
          class="card-style"
          :style="{
            height: (containHeight-50)+'px'
          }"
        >
          <TabItem
            :props-params="purposeTypeListProps"
          />
        </v-card>
        <v-card
          v-show="selected_tab===tabs_list[4].value"
          class="card-style"
        >
          <v-card-subtitle>科目新建后，将在10分钟后同步至金蝶, 同步后需在MIS和金蝶同时修改</v-card-subtitle>
          <v-card-text>
            <div
              v-if="sync_pending_account_titles.length"
              class="line"
            >
              待同步:
              <v-chip
                v-for="title in sync_pending_account_titles"
                :key="title.id"
                x-small
                color="primary"
                outlined
              >
                {{ title.full_name }}
              </v-chip>
            </div>
            <div
              v-if="sync_failed_account_titles.length"
              class="line"
            >
              同步失败:
              <v-chip
                v-for="title in sync_failed_account_titles"
                :key="title.id"
                x-small
                color="red"
                outlined
              >
                {{ title.full_name }}
              </v-chip>
              <small class="red--text">
                请联系开发查找失败原因
              </small>
            </div>
          </v-card-text>
          <TreeItem
            :props-params="accountantProps"
          />
        </v-card>
        <v-card
          v-show="selected_tab===tabs_list[5].value"
          class="card-style"
        >
          <TreeItem
            :props-params="analysisProps"
          />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script route="/subject_iteration/subject_iteration">
  import {
    tabs_list,
    functional_header_fields,
    item_type_header_fields,
    nature_header_fields,
    use_type_header_fields
  } from './fields'
  import { NAME_SPACE } from './constants'
  import TabItem from './components/TabItem'
  import TreeItem from './components/TreeItem'
  import BczPagination from './components/BczPagination'
  import {mapActions, mapGetters, mapState} from 'vuex'
  export default {
    components: {
      TabItem,
      TreeItem,
      BczPagination
    },
    data() {
      this.tabs_list = tabs_list
      return {
        selected_tab:tabs_list[0].value,
        params: {
          page:1
        }
      }
    },
    methods: {
      ...mapActions(NAME_SPACE,
                    [
                      'getExpenseNatureList',
                      'getCustomerFunctionList',
                      'setAddAndUpdateCustomerFunctionSave',
                      'setcustomerFunctionStatus',
                      'getItemTypeList',
                      'addItemType',
                      'setItemTypeStatus',
                      'setExpenseNatureStatus',
                      'addAndUpdateNature',
                      'getAccountTitleAll',
                      'addAccountTitleSave',
                      'changeAccountTitleStatus',
                      'getAnalysisTitleAll',
                      'addAnalysisTitleSave',
                      'changeAnalysisTitleStatus',
                      'getFundUseageList',
                      'setFundUsageSave',
                      'changeFundUsageStatus'
                    ]),
      proxyGet() {
        switch (this.selected_tab) {
        case this.tabs_list[0].value:
          if (this.natureList && this.natureList.length !== 0) {
            return
          }
          this.getExpenseNatureList()
          break
        case this.tabs_list[1].value:
          if (this.customerFunctionList && this.customerFunctionList.length !== 0) {
            return
          }
          this.getCustomerFunctionList()
          break
        case this.tabs_list[2].value:
          if (this.itemTypeList && this.itemTypeList.length !== 0) {
            return
          }
          this.getItemTypeList()
          break
        case this.tabs_list[3].value:
          if (this.fundUsageList && this.fundUsageList.length !== 0) {
            return
          }
          this.getFundUseageList()
          break
        case this.tabs_list[4].value:

          this.getAccountTitleAll()
          break
        case this.tabs_list[5].value:
          this.getAnalysisTitleAll()
          break

        default:
          break
        }
      },
      changeTab() {
        this.proxyGet()
      }
    },
    computed:{
      ...mapState(NAME_SPACE, {
        natureList:'natureList',
        loading:'loading',
        customerFunctionList: 'customerFunctionList',
        itemTypeList: 'itemTypeList',
        accountTitleAllList: 'accountTitleAllList',
        analysisTitleAllList: 'analysisTitleAllList',
        fundUsageList:'fundUsageList',
      }),
      ...mapGetters('async', ['account_leaf_titles']),
      sync_pending_account_titles() {
        return this.account_leaf_titles.filter(t => t.sync_status === 'pending')
      },
      sync_failed_account_titles() {
        return this.account_leaf_titles.filter(t => t.sync_status === 'failed')
      },
      // 费用nature
      expenseNatureProps() {
        return {
          tableFields: nature_header_fields,
          tableList: this.natureList,
          getData: this.getExpenseNatureList,
          needSynonyms: true,
          tableLoading: this.loading.getExpenseNatureListLoading,
          addAndEdit: this.addAndUpdateNature,
          saveLoading: this.loading.addAndUpdateNatureLoading,
          editModalField: '费用名称',
          changeStatus:this.setExpenseNatureStatus,
          changeStatusLoading: this.loading.setExpenseNatureStatusLoading,
          needPageInfor: true
        }
      },
      // 职能
      functionalProps() {
        return {
          tableFields:functional_header_fields,
          tableList: this.customerFunctionList,
          tableLoading: this.loading.getCustomerFunctionListLoading,
          addAndEdit: this.setAddAndUpdateCustomerFunctionSave,
          saveLoading: this.loading.setAddAndUpdateCustomerFunctionSaveLoading,
          editModalField: '职能名称',
          changeStatus:this.setcustomerFunctionStatus,
          changeStatusLoading: this.loading.setcustomerFunctionStatusLoading,
          enterSubmit: true
        }
      },
      // 产品
      getItemTypeListProps() {
        return {
          tableFields:item_type_header_fields,
          tableList: this.itemTypeList,
          tableLoading: this.loading.getItemTypeListLoading,
          addAndEdit: this.addItemType,
          saveLoading: this.loading.addItemTypeLoading,
          editModalField: '产品类别',
          changeStatus:this.setItemTypeStatus,
          changeStatusLoading: this.loading.setItemTypeStatusLoading,
          enterSubmit:true
        }
      },
      // 用途
      purposeTypeListProps() {
        return {
          tableFields:use_type_header_fields, //
          tableList: this.fundUsageList, //
          tableLoading: this.loading.getFundUseageListLoading, //
          addAndEdit: this.setFundUsageSave, //
          saveLoading: this.loading.setFundUsageSaveLoading,
          editModalField: '用途名称', //
          changeStatus:this.changeFundUsageStatus,
          changeStatusLoading: this.loading.changeFundUsageStatusLoading,
          enterSubmit: true
        }
      },
      // 会计科目
      accountantProps() {
        return {
          treeList: this.accountTitleAllList,
          editModalField: '科目名称',
          addAndEdit: this.addAccountTitleSave,
          saveLoading: this.loading.addAccountTitleSaveLoading,
          treeMaxLevel: Infinity,
          changeStatus:this.changeAccountTitleStatus,
          changeStatusLoading: this.loading.changeAccountTitleStatusLoading,
          enterSubmit: true,
          showAc:true
        }
      },
      // 分析科目
      analysisProps() {
        return {
          treeList: this.analysisTitleAllList,
          editModalField: '科目名称',
          addAndEdit: this.addAnalysisTitleSave,
          saveLoading: this.loading.addAnalysisTitleSaveLoading,
          treeMaxLevel: 4,
          changeStatus: this.changeAnalysisTitleStatus,
          changeStatusLoading: this.loading.changeAnalysisTitleStatusLoading,
          enterSubmit: true
        }
      },
      containHeight() {
        const window_height = this.$store.state.window_height;
        return window_height - 180;
      }
    },
    mounted() {
      this.proxyGet()
    }
  }
</script>
